import { useQuery } from "react-query";
import { request } from "../../../config/helpers/axios-instance";
import { throwIfRequestError } from "../../hooks/request-error";

// Medicine catalog — GET /api/item/admin.
//
// Same endpoint and the same `name`/`page`/`size`/`order`/`orderBy` params the legacy
// Medicine Master page already uses (src/pages/medicine-master/components/AllMedicines.jsx),
// so the pharmacy Inventory view is a second reader of one catalog rather than a second
// definition of it. Field names below (`mnemonic`, `manufacture`, `genericName`,
// `medicineType`, `inventoryId`) are that page's own accessors — including the singular
// "manufacture", which is the API's spelling and not a typo here.
//
// The prototype's Inventory has extra attributes (shape, colour, size) that this endpoint
// does not carry; they are omitted rather than rendered as permanently empty columns.
export default function useMedicineCatalog({ search = "", page = 1, size = 20, enabled = true } = {}) {
    const params = { page, size };
    if (search) params.name = search;

    return useQuery(
        ["pharmacy-medicines", params],
        async () => {
            const result = await request({ url: "item/admin", method: "GET", params });
            throwIfRequestError(result);
            const body = result.data;
            // pillup-api answers HTTP 200 even on failure — errors are in-band, so the
            // HTTP-level check above cannot see them.
            if (!body?.success) throw body;

            const { count, rows } = body.data;
            return {
                medicines: rows || [],
                pagination: { page, size, total: Number(count) || 0 },
            };
        },
        { keepPreviousData: true, retry: false, enabled }
    );
}
